// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/MelaAct2.png";
import thumb1 from "../assets/images/All-Products/Mela-Act-Cream-2.0-Image.png";
import thumb2 from "../assets/images/All-Products/MelaAct2.png";
import thumb3 from "../assets/images/All-Products/Mela-Act-Cream-2.0-Image.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>MelaAct 2.0 </h2>
              <p className="sub-heading text-muted">TREATS DERMAL EPIDERMAL PIGMENTATION </p>
              <h5>Product Overview</h5>
              <p>
                Mela Act is an effective topical treatment for maintenance of Melasma & Chloasma,
                post inflammatory hyperpigmentation and UV induced hyperpigmentation.
                It possesses Tranexamic acid which reduces recurrence of the disease by exerting its effects on pigmentation.
                It is formulated with essential ingredients which reduce the degree of suntan after UV exposure.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">MelaAct 2.0?</span>
                </h3>
                <p>
                  Once or twice daily can be used or as recommended by the Dermatologist.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Paraben and steroid free cream.</li>
                    <li>It has good patient compliance.</li>
                  </ul>



                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Cleanse the face and pat dry gently.</li>
                      <li>Take a small quantity of cream onto your fingertips and apply on the affected areas.</li>
                      <li>Use once or twice daily, or as recommended by the Dermatologist.</li>
                    </ol>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Tranexamic acid:</strong> Reduces recurrence of the disease by acting as a plasmin inhibitor and blocking the effects of melanin.</li>
                      <li><strong>Kojic acid:</strong> Potent tyrosinase inhibitor with anti-inflammatory and anti-wrinkle properties.</li>
                      <li><strong>Mulberry extract &amp; Arbutin:</strong> Helps in minimizing pigmentation and protects the skin from UV exposure.</li>
                    </ul>


                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
